<template>
    <transition name="modal">
        <div v-show="isVisible" class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">

                    <div class="modal-header">
                        <slot name="header">
                            <h5>{{ title }}</h5>
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                            {{ message }}
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <button type="button" class="btn btn-primary" @click="onConfirm"><i class="fa fa-check" aria-hidden="true"></i> {{ translate('RecordManager.form.confirm') }}</button>

                            <button type="button" class="btn btn-secondary" @click="onCancel"><i class="fa fa-times" aria-hidden="true"></i> {{ translate('RecordManager.form.cancel') }}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            id: { type: Number, required: true },
            title: { type: String, required: true, default: "Confirm" },
            message: { type: String, required: true, default: "Are you sure?" }
        },

        data() {
            return {
                isVisible: false,
                onConfirmCallback: undefined,
                onCancelCallback: undefined
            }
        },

        created() {
            EventDispatcher.listen('showConfirmationDialog' + this.id, (handlers) => {
                // save the callback functions and invoke them when the confirm or cancel button is pressed
                this.onConfirmCallback = handlers.onConfirmCallback;
                this.onCancelCallback = handlers.onCancelCallback;

                // show the confirmation dialog
                this.show();
            });
        },

        methods: {
            show() {
                this.isVisible = true;
            },

            close() {
                this.isVisible = false;
            },

            onConfirm() {
                // invoke the confirm callback function
                if(this.onConfirmCallback) {
                    this.onConfirmCallback();
                }

                // close the confirmation dialog after the confirm button is pressed
                this.close();
            },

            onCancel() {
                // invoke the cancel callback function
                if(this.onCancelCallback) {
                    this.onCancelCallback();
                }

                // close the confirmation dialog when the cancel button is pressed
                this.close();
            }
        }
    }
</script>

<style lang="scss">
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 400px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container, .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>